module.exports = __webpack_public_path__ + "static/img/SE-Shareholders_SSD2017.f94d6b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/SE-Shareholders_SSD2017.jpg
// module id = /Vxs
// module chunks = 0